import React from 'react'
import { Message } from '../Message'
import { Stack } from '~/styles'

export const ErrorMessage = (): JSX.Element => {
  return (
    <Message.RootLeft>
      <Message.UserAvatar iconName="MiMaleDoctor" />
      <Stack spacing="0.5rem" alignItems="flex-start">
        <Message.UserName username="IA Interativa" />
        <Message.FromLeft>
          <Message.PlainText text="Erro inesperado, contacte o administrador..." />
        </Message.FromLeft>
      </Stack>
    </Message.RootLeft>
  )
}
